module.exports = __webpack_public_path__ + "img/drivers-placeholder.d5d922a6.png";